import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

//import Home from "../views/Home.vue";
import SignIn from "../views/auth/SignIn.vue";
import OrderPayment from "../views/orders/OrderPayment.vue";
import Welcome from "../views/Welcome.vue";

const Home = () =>
  import(
    /* webpackChunkName: "group-auth" */
    "../views/Home.vue"
  );

const Registration = () =>
  import(
    /* webpackChunkName: "group-auth" */
    "../views/auth/Registration.vue"
  );
const PasswordReset = () =>
  import(
    /* webpackChunkName: "group-auth" */
    "../views/auth/PasswordReset.vue"
  );

const NotFound = () =>
  import(
    /* webpackChunkName: "group-404" */
    "../views/404.vue"
  );

const Account = () =>
  import(
    /* webpackChunkName: "group-user" */
    "../views/user/Account.vue"
  );
const AddCard = () =>
  import(
    /* webpackChunkName: "group-user" */
    "../views/user/AddNewCard.vue"
  );
const CopyStatement = () =>
  import(
    /* webpackChunkName: "group-user" */
    "../views/accounts/CopyStatement.vue"
  );

const CopyInvoice = () =>
  import(
    /* webpackChunkName: "group-account" */
    "../views/accounts/CopyInvoice.vue"
  );
const Settings = () =>
  import(
    /* webpackChunkName: "group-account" */
    "../views/user/Settings.vue"
  );

const FAQ = () =>
  import(
    /* webpackChunkName: "group-user" */
    "../views/user/FAQ.vue"
  );

const OrdersCreate = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/Create.vue"
  );

const OrdersBasketSelection = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/create/BasketSelection.vue"
  );

const OrdersSearch = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/create/Search.vue"
  );

const OrdersSearchProduct = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/create/search/_prod_no.vue"
  );

const OrdersSearchGroups = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/create/search/Groups.vue"
  );

const OrdersSearchGroupCategories = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/create/search/Categories.vue"
  );

const OrdersSearchTemplates = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/create/search/Templates.vue"
  );

const OrdersSearchProductInfo = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/create/search/info/Info.vue"
  );

const OrdersBasket = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/create/Basket.vue"
  );

const OrdersCheckout = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/create/Checkout.vue"
  );

const OrdersPreCheckout = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/create/PreCheckout.vue"
  );

const OrdersConfirmation = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/create/Confirmation.vue"
  );

const OrdersTemplate = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/Template.vue"
  );

const OrdersTemplateCreate = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/template/TemplateCreate.vue"
  );

const OrdersTemplateEdit = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/template/TemplateEdit.vue"
  );

const OrdersTemplateGroups = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/template/TemplateGroups.vue"
  );

const OrdersTemplateCategories = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/template/TemplateCategories.vue"
  );

const OrdersTemplateProductInfo = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/template/TemplateProductInfo.vue"
  );

const OrdersTemplateComplete = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/template/TemplateComplete.vue"
  );

const OrdersStanding = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/StandingOrders.vue"
  );

const YourOrders = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/YourOrders.vue"
  );

const RecreateOrder = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/yourorders/RecreateOrder.vue"
  );

const OrderDetails = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/yourorders/OrderDetails.vue"
  );
const TicketDetails = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/yourorders/TicketDetails.vue"
  );

const PaymentSuccess = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/orders/PaymentSuccess.vue"
  );

const ChangeUserDetails = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/user/ChangeUserDetails.vue"
  );

const AddressesForm = () =>
  import(
    /* webpackChunkName: "group-account" */
    "../views/user/account/addresses/Form.vue"
  );

const AddressesSelect = () =>
  import(
    /* webpackChunkName: "group-account" */
    "../views/user/account/addresses/Select.vue"
  );

const ChangePassword = () =>
  import(
    /* webpackChunkName: "group-reports" */
    "../views/user/ChangePassword.vue"
  );
const AllergenReport = () =>
  import(
    /* webpackChunkName: "group-reports" */
    "../views/reports/AllergenReport.vue"
  );
const NutritionReport = () =>
  import(
    /* webpackChunkName: "group-reports" */
    "../views/reports/NutritionReport.vue"
  );

const SalesReport = () =>
  import(
    /* webpackChunkName: "group-orders" */
    "../views/reports/SalesReport.vue"
  );

const AccountPayment = () =>
  import(
    /* webpackChunkName: "group-account" */
    "../views/accounts/AccountPayment.vue"
  );

const PaymentHistory = () =>
  import(
    /* webpackChunkName: "group-account" */
    "../views/accounts/PaymentHistory.vue"
  );
const StandingOrderCreate = () =>
  import(
    /* webpackChunkName: "group-account" */
    "../views/orders/standing/StandingCreate.vue"
  );

const StandingOrderConfirm = () =>
  import(
    /* webpackChunkName: "group-account" */
    "../views/orders/standing/StandingConfirm.vue"
  );

const StandingOrderProducts = () =>
  import(
    /* webpackChunkName: "group-account" */
    "../views/orders/standing/StandingProducts.vue"
  );

const StandingOrderGroups = () =>
  import(
    /* webpackChunkName: "group-account" */
    "../views/orders/standing/StandingGroups.vue"
  );

const StandingOrderCategories = () =>
  import(
    /* webpackChunkName: "group-account" */
    "../views/orders/standing/StandingCategories.vue"
  );

const StandingOrderProductInfo = () =>
  import(
    /* webpackChunkName: "group-account" */
    "../views/orders/standing/StandingProductInfo.vue"
  );

const CustomerSearch = () =>
  import(
    /* webpackChunkName: "group-account" */
    "../views/admin/CustomerSearch.vue"
  );

const MaintenancePostcodes = () =>
  import(
    /* webpackChunkName: "group-maintenance" */
    "../views/maintenance/Postcodes/Index.vue"
  );

const MaintenancePostcodesAdd = () =>
  import(
    /* webpackChunkName: "group-maintenance" */
    "../views/maintenance/Postcodes/Add.vue"
  );

const MaintenanceOrderdiscounts = () =>
  import(
    /* webpackChunkName: "group-maintenance" */
    "../views/maintenance/Orderdiscounts/Index.vue"
  );

const MaintenanceOrderdiscountsAdd = () =>
  import(
    /* webpackChunkName: "group-maintenance" */
    "../views/maintenance/Orderdiscounts/Add.vue"
  );
  const BusinessRegistration = () =>
  import(
    /* webpackChunkName: "group-maintenance" */
    "../views/auth/BusinessAccountRegistration.vue"
  );

Vue.use(VueRouter);
const routes = [
  //If there's no route direct to our home page
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [],
    },
  },
  {
    path: "/Welcome",
    name: "Welcome",
    component: Welcome,
    meta: {
      requiresAuth: false,
      allowGuest: true,
      showMenu: false,
      breadCrumbs: [],
    },
  },
  {
    path: "/auth/signin",
    name: "SignIn",
    component: SignIn,
    meta: {
      requiresAuth: false,
      allowGuest: true,
      showMenu: false,
      breadCrumbs: [],
    },
  },
  {
    path: "/auth/business-account-registration",
    name: "BusinessRegistration",
    component: BusinessRegistration,
    meta: {
      requiresAuth: false,
      allowGuest: true,
      showMenu: false,
      breadCrumbs: [],
    },
  },

  {
    path: "/auth/registration",
    name: "Registration",
    component: Registration,
    meta: {
      requiresAuth: false,
      allowGuest: true,
      showMenu: false,
      breadCrumbs: [],
    },
  },
  {
    path: "/auth/passwordreset",
    name: "PasswordReset",
    component: PasswordReset,
    meta: {
      requiresAuth: false,
      allowGuest: true,
      showMenu: false,
      breadCrumbs: [],
    },
  },
  {
    path: "/404",
    name: "404",
    component: NotFound,
    meta: {
      requiresAuth: true,
      allowGuest: true,
      showMenu: true,
      breadCrumbs: [],
    },
  },

  {
    path: "/customersearch",
    name: "CustomerSearch",
    component: CustomerSearch,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "CustomerSearch" },
          text: "Customer Search",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/user/faq",
    name: "FAQ",
    component: FAQ,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "FAQ" },
          text: "FAQ",
          exact: true,
        },
      ],
    },
  },
  {
    path: "/accounts/statement",
    name: "CopyStatement",
    component: CopyStatement,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "CopyStatement" },
          text: "Statement Copy",
          exact: true,
        },
      ],
    },
  },
  {
    path: "/accounts/invoice",
    name: "CopyInvoice",
    component: CopyInvoice,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "CopyInvoice" },
          text: "Invoice Copy",
          exact: true,
        },
      ],
    },
  },
  {
    path: "/accounts/payment",
    name: "AccountPayment",
    component: AccountPayment,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "AccountPayment" },
          text: "Payment on Account",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/accounts/paymenthistory",
    name: "PaymentHistory",
    component: PaymentHistory,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "PaymentHistory" },
          text: "Payment History",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/reports/sales",
    name: "SalesReport",
    component: SalesReport,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "SalesReport" },
          text: "Sales Report",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/reports/allergen",
    name: "AllergenReport",
    component: AllergenReport,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "AllergenReport" },
          text: "Allergen Report",
          exact: true,
        },
      ],
    },
  },
  {
    path: "/reports/nutrition",
    name: "NutritionReport",
    component: NutritionReport,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "NutritionReport" },
          text: "Nutrition Report",
          exact: true,
        },
      ],
    },
  },
  {
    path: "/user/account",
    name: "UserAccount",
    component: Account,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "UserAccount" },
          text: "Account",
          exact: true,
        },
      ],
    },
  },
  {
    path: "/user/account/addcard",
    name: "AddNewCard",
    component: AddCard,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "UserAccount" },
          text: "Account",
          exact: true,
        },
        {
          to: { name: "AddNewCard" },
          text: "Add Card",
          exact: true,
        },
      ],
    },
  },
  {
    path: "/user/account/edit",
    name: "ChangeUserDetails",
    component: ChangeUserDetails,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "UserAccount" },
          text: "Account",
          exact: true,
        },
        {
          to: { name: "ChangeUserDetails" },
          text: "Edit User",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/user/account/changepassword",
    name: "ChangePassword",
    component: ChangePassword,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "UserAccount" },
          text: "Account",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/user/settings",
    name: "UserSettings",
    component: Settings,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "UserSettings" },
          text: "Settings",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/user/account/addresses/form",
    name: "DeliveryAddressForm",
    component: AddressesForm,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "UserAccount" },
          text: "Account",
          exact: true,
        },
        {
          to: { name: "DeliveryAddressForm" },
          text: "Form",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/user/account/addresses/select",
    name: "DeliveryAddressSelect",
    component: AddressesSelect,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "UserAccount" },
          text: "Account",
          exact: true,
        },
        {
          to: { name: "DeliveryAddressSelect" },
          text: "Select",
          exact: true,
        },
      ],
    },
  },

  //Orders routes
  {
    path: "/orders/create",
    name: "OrdersCreate",
    component: OrdersCreate,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "OrdersCreate" },
          text: "Create",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/basketselection",
    name: "OrdersBasketSelection",
    component: OrdersBasketSelection,
    props: true,

    meta: {
      requiresAuth: true,
      allowGuest: true,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "OrdersBasketSelection" },
          text: "Basket Selection",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/create/search",
    name: "OrdersSearch",
    component: OrdersSearch,
    props: true,

    meta: {
      requiresAuth: true,
      allowGuest: true,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "OrdersCreate" },
          text: "Create",
          exact: true,
        },
        {
          to: { name: "OrdersSearch" },
          text: "Search",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/create/search/groups",
    name: "OrdersSearchGroups",
    component: OrdersSearchGroups,
    meta: {
      requiresAuth: true,
      allowGuest: true,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "OrdersCreate" },
          text: "Create",
          exact: true,
        },
        {
          to: { name: "OrdersSearch" },
          text: "Search",
          exact: true,
        },
        {
          to: { name: "OrdersSearchGroups" },
          text: "Groups",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/create/search/groups/:id/categories",
    name: "OrdersSearchGroupCategories",
    component: OrdersSearchGroupCategories,
    meta: {
      requiresAuth: true,
      allowGuest: true,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "OrdersCreate" },
          text: "Create",
          exact: true,
        },
        {
          to: { name: "OrdersSearch" },
          text: "Search",
          exact: true,
        },
        {
          to: { name: "OrdersSearchGroups" },
          text: "Groups",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/create/search/templates",
    name: "OrdersSearchTemplates",
    component: OrdersSearchTemplates,
    meta: {
      requiresAuth: true,
      allowGuest: true,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "OrdersCreate" },
          text: "Create",
          exact: true,
        },
        {
          to: { name: "OrdersSearch" },
          text: "Search",
          exact: true,
        },
        {
          to: { name: "OrdersSearchTemplates" },
          text: "Templates",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/create/search/:id",
    name: "OrdersSearchProduct",
    component: OrdersSearchProduct,
    props: true,

    meta: {
      requiresAuth: true,
      allowGuest: true,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "OrdersCreate" },
          text: "Create",
          exact: true,
        },
        {
          to: { name: "OrdersSearch" },
          text: "Search",
          exact: true,
        },
        {
          to: { name: "OrdersSearchProduct" },
          text: "Product",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/create/search/:id/info",
    name: "OrdersSearchProductInfo",
    component: OrdersSearchProductInfo,
    props: true,

    meta: {
      requiresAuth: true,
      allowGuest: true,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "OrdersCreate" },
          text: "Create",
          exact: true,
        },
        {
          to: { name: "OrdersSearch" },
          text: "Search",
          exact: true,
        },
        {
          to: { name: "OrdersSearchProduct" },
          text: "Product",
          exact: true,
        },
        {
          to: { name: "OrdersSearchProductInfo" },
          text: "Info",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/create/basket",
    name: "OrdersBasket",
    component: OrdersBasket,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "OrdersCreate" },
          text: "Create",
          exact: true,
        },
        {
          to: { name: "OrdersBasket" },
          text: "Basket",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/create/precheckout",
    name: "OrdersPreCheckout",
    component: OrdersPreCheckout,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "OrdersCreate" },
          text: "Create",
          exact: true,
        },
        {
          to: { name: "OrdersBasket" },
          text: "Basket",
          exact: true,
        },
        {
          to: { name: "OrdersPreCheckout" },
          text: "User Info",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/create/checkout",
    name: "OrdersCheckout",
    component: OrdersCheckout,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "OrdersCreate" },
          text: "Create",
          exact: true,
        },
        {
          to: { name: "OrdersBasket" },
          text: "Basket",
          exact: true,
        },
        {
          to: { name: "OrdersCheckout" },
          text: "Checkout",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/create/confirmation",
    name: "OrdersConfirmation",
    component: OrdersConfirmation,
    props: true,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "OrdersCreate" },
          text: "Create",
          exact: true,
        },
        {
          to: { name: "OrdersConfirmation" },
          text: "Confirmation",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/template",
    name: "TemplateOrders",
    component: OrdersTemplate,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "TemplateOrders" },
          text: "Templates",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/template/create",
    name: "TemplateOrdersCreate",
    component: OrdersTemplateCreate,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "TemplateOrders" },
          text: "Templates",
          exact: true,
        },
        {
          to: { name: "TemplateOrdersCreate" },
          text: "Create",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/template/edit",
    name: "TemplateOrdersEdit",
    component: OrdersTemplateEdit,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "TemplateOrders" },
          text: "Templates",
          exact: true,
        },
        {
          to: { name: "TemplateOrdersEdit" },
          text: "Edit",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/template/edit/groups",
    name: "TemplateOrdersGroups",
    component: OrdersTemplateGroups,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "TemplateOrders" },
          text: "Templates",
          exact: true,
        },
        {
          to: { name: "TemplateOrdersEdit" },
          text: "Edit",
          exact: true,
        },
        {
          to: { name: "TemplateOrdersGroups" },
          text: "Groups",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/template/edit/groups/:id/categories",
    name: "TemplateOrdersCategories",
    component: OrdersTemplateCategories,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "TemplateOrders" },
          text: "Templates",
          exact: true,
        },
        {
          to: { name: "TemplateOrdersEdit" },
          text: "Edit",
          exact: true,
        },
        {
          to: { name: "TemplateOrdersGroups" },
          text: "Groups",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/template/edit/:id/info",
    name: "TemplateOrdersProductInfo",
    component: OrdersTemplateProductInfo,
    props: true,

    meta: {
      requiresAuth: true,
      allowGuest: true,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "TemplateOrders" },
          text: "Templates",
          exact: true,
        },
        {
          to: { name: "TemplateOrdersEdit" },
          text: "Edit",
          exact: true,
        },
        {
          to: { name: "TemplateOrdersProductInfo" },
          text: "Info",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/template/complete",
    name: "TemplateOrdersComplete",
    component: OrdersTemplateComplete,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "TemplateOrders" },
          text: "Templates",
          exact: true,
        },

        {
          to: { name: "TemplateOrdersComplete" },
          text: "Done",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/standingorders",
    name: "StandingOrders",
    component: OrdersStanding,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "StandingOrders" },
          text: "Standing Orders",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/standing/create",
    name: "StandingOrderCreate",
    component: StandingOrderCreate,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "StandingOrders" },
          text: "Standing Orders",
          exact: true,
        },
        {
          to: { name: "StandingOrderCreate" },
          text: "Create",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/standing/create-products",
    name: "StandingOrderProducts",
    component: StandingOrderProducts,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "StandingOrders" },
          text: "Standing Orders",
          exact: true,
        },
        {
          to: { name: "StandingOrderProducts" },
          text: "Products",
          exact: true,
        },
      ],
    },
  },
  {
    path: "/orders/standing/create/confirm",
    name: "StandingOrderConfirm",
    component: StandingOrderConfirm,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "StandingOrders" },
          text: "Standing Orders",
          exact: true,
        },
        {
          to: { name: "StandingOrderProducts" },
          text: "Products",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/standing/create-products/groups",
    name: "StandingOrderGroups",
    component: StandingOrderGroups,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "StandingOrders" },
          text: "Standing Orders",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/standing/create-products/groups/:id/categories",
    name: "StandingOrderCategories",
    component: StandingOrderCategories,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "StandingOrders" },
          text: "Standing Orders",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/standing/create-products/:id/info",
    name: "StandingOrderProductInfo",
    component: StandingOrderProductInfo,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "StandingOrders" },
          text: "Standing Orders",
          exact: true,
        },
        {
          to: { name: "StandingOrderProducts" },
          text: "Products",
          exact: true,
        },
        {
          to: { name: "StandingOrderProductInfo" },
          text: "Product Information",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/yourorders",
    name: "YourOrders",
    component: YourOrders,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "YourOrders" },
          text: "Your Orders",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/yourorders/recreate/:td_id",
    name: "RecreateOrder",
    component: RecreateOrder,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "YourOrders" },
          text: "Your Orders",
          exact: true,
        },
        {
          to: { name: "RecreateOrder" },
          text: "Recreate Order",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/yourorders/:td_id",
    name: "OrderDetails",
    component: OrderDetails,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "YourOrders" },
          text: "Your Orders",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/orders/yourorders/:invoice_no",
    name: "TicketDetails",
    component: TicketDetails,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "YourOrders" },
          text: "Your Orders",
          exact: true,
        },
      ],
    },
  },
  {
    path: "/orders/orderpayment",
    name: "OrderPayment",
    component: OrderPayment,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
    },
  },
  {
    path: "/orders/paymentsuccess/:td_id/:payment_ref",
    name: "PaymentSuccess",
    component: PaymentSuccess,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
    },
  },

  // == Maintenance Routes Below ==
  {
    path: "/maintenance/postcodes/",
    name: "MaintenancePostcodes",
    component: MaintenancePostcodes,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "MaintenancePostcodes" },
          text: "Postcodes",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/maintenance/postcodes/add",
    name: "MaintenancePostcodesAdd",
    component: MaintenancePostcodesAdd,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "MaintenancePostcodes" },
          text: "Postcodes",
          exact: true,
        },
        {
          to: { name: "MaintenancePostcodesAdd" },
          text: "Add",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/maintenance/orderdiscounts/",
    name: "MaintenanceOrderdiscounts",
    component: MaintenanceOrderdiscounts,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "MaintenanceOrderdiscounts" },
          text: "Order Discounts",
          exact: true,
        },
      ],
    },
  },

  {
    path: "/maintenance/orderdiscounts/add",
    name: "MaintenanceOrderdiscountsAdd",
    component: MaintenanceOrderdiscountsAdd,
    meta: {
      requiresAuth: true,
      allowGuest: false,
      showMenu: true,
      breadCrumbs: [
        {
          to: { name: "Home" },
          text: "Home",
          exact: true,
        },
        {
          to: { name: "MaintenanceOrderdiscounts" },
          text: "Order Discounts",
          exact: true,
        },
        {
          to: { name: "MaintenanceOrderdiscountsAdd" },
          text: "Add",
          exact: true,
        },
      ],
    },
  },

  //Here we redirect all traffic which is to an invalid route to our home page
  {
    path: "*",
    redirect: "/404",
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

//Route protection checking
// -- If our route requires authentication then ensure we're logged in before we let the users go there
router.beforeEach(async (to, from, next) => {
  let routeReqAuth = to.matched.some((record) => record.meta.requiresAuth);
  let routeIsWelcome = to.matched.some((record) => record.path == "/Welcome");
  let routeReqCustomer = to.matched.some((record) =>
    record.path.startsWith("/orders") || record.path.startsWith('/accounts')
  );

  if (routeReqAuth) {
    // This route requires auth, check our user to see if we're authed
    // -- First check if the user even exists
    if (store.getters.retrieveUser != null) {
      // The user does exist so check if we're authed
      if (store.getters.retrieveUser.auth) {
        if (store.getters.retrieveAdmin == null) {
          let res = await store.dispatch("getAdmin");
          console.log("-- Got Admin Response -- ");
        }

        if (
          routeReqCustomer &&
          store.getters.retrieveSelectedCustomer == null
        ) {
          console.log("Route requires a selected customer");
          console.log("Intended Route -- " + to.name);
          next({ name: "CustomerSearch", query: { dest_name: to.name } });
          //next({path : `/customersearch?redirect=${from.fullPath}`})
          // to.path(`/customersearch?redirect=${from.fullPath}`)
        } else {
          //Get our essential info here IF it doesn't already exist
          if (
            checkRefreshCustomer() &&
            store.getters.retrieveSelectedCustomer
          ) {
            console.log("Going to hit getCustomer");
            try {
              let response = await store.dispatch("getCustomer");
              console.log("-- Got Cust Response");
              console.log(response);

              if (response.success == true) {
                next();
              } else {
                console.log("Error has occured");
                console.log(response);
                // this.loadingCustomer = false;

                store.dispatch("snackbarStatic/setSnackbar", {
                  text: response.message,
                  color: "error",
                });

                store.dispatch("userSignoutAction");
                this.$router.push({ name: "SignIn" }).catch((error) => {
                  //handle error here
                  console.log(error);
                });
              }
            } catch (ex) {
              console.log("-- Failed to Load Data");
            }
          } else {
            next();
          }
        }
      } else {
        //We are not authed so go to the SignIn page / welcome page

        if (process.env.VUE_APP_NO_WELCOME_PAGE == "true") {
          next({ name: "SignIn" });
        } else {
          next({ name: "Welcome" });
        }
        // console.log('Hitting not auth and redirect to welcome page');
        // next({ name: "Welcome" });
      }
    } else {
      // Our user does not exist, so previously logged out or are a fresh user
      // -- Send to the SignIn page

      if (process.env.VUE_APP_NO_WELCOME_PAGE == "true") {
        next({ name: "SignIn" });
      } else {
        next({ name: "Welcome" });
      }
      // console.log('Hitting fresh user no welcome page');
      // next({ name: "Welcome" });
    }
  } else {
    // Route does not require an auth so allow the user to view it
    // -- This is in case of things like SignIn and registration pages
    next();
  }

  //Check if the user is a guest user
  if (store.getters.retrieveGuest) {
    //Guest user
    if (to.matched.some((record) => record.meta.allowGuest)) {
      next();
    } else {
      next({ name: "Welcome" });
    }
  }

  if (routeIsWelcome) {
    if (process.env.VUE_APP_NO_WELCOME_PAGE == "true") {
      next({ name: "SignIn" });
    } else {
      next({ name: "Welcome" });
    }
  }

  /* BLOCK CAUSING REDIRECT TO HOME PAGE WHEN NOT AUTHENTICATED @ /#/
  else {
    //NOT a guest user
    next();
  }*/
});

function checkRefreshCustomer() {
  let refreshCustomer = true;

  //Check if we have the customer set first
  // -- If not always refresh
  if (store.getters.retrieveCustomer != 'no_customers') {
    //If the customer was last refreshed > 2 hours ago
    // -- Refresh cusstomer
    if (store.getters.retrieveCustomerUpdatedTime != null) {
      let comparison =
        new Date().getTime() - store.getters.retrieveCustomerUpdatedTime;
      let hoursComparison = comparison / (1000 * 60 * 60);
      if (hoursComparison > 1) {
        refreshCustomer = true;
      } else {
        refreshCustomer = false;
      }
    }
  }

  return refreshCustomer;
}

export default router;
